import App from 'apps/App';

export default [
  {
    path: '/',
    component: App,
  },
];
